import { apiGetAuth, apiGetAuthWithCustomHeadersResponseType } from '@/utils/api'
import { notificationDanger } from '@/utils/notification'
import { currencyLocale } from '@/utils/formater'
import { exportCustomHeaderAndResponseType } from '@/utils/helper'
import { API_PLANOGRAM_ANALYTICS } from '@/utils/api-url'

const getDefaultState = () => ({
  summaryDataSales: [
    { label: "Total Difference", subLabel: "SALES ORDER", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "REDEEM ALP", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "PROMOTION ECOMMERCE", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "SALES FINAL", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "DELIVERY FEE", value: 'Rp. 0' }
  ],
  tableDataSales: [],
  summaryDataRefund: [
    { label: "Total Difference", subLabel: "ALL REFUND", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "REFUND ALP", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "REFUND XENDIT", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "REFUND EVOUCHER ", value: 'Rp. 0' },
    { label: "Total Difference", subLabel: "REFUND LIMIT", value: 'Rp. 0' }
  ],
  tableDataRefund: [],
  isLoading: false,
  isLoadingSummary: false
})

const state = getDefaultState()

const getters = {
  summaryDataSales: state => state.summaryDataSales,
  tableDataSales: state => state.tableDataSales,
  summaryDataRefund: state => state.summaryDataRefund,
  tableDataRefund: state => state.tableDataRefund,
  isLoading: state => state.isLoading,
  isLoadingSummary: state => state.isLoadingSummary
}

const mutations = {
  SET_SUMMARY_DATA_SALES(state, payload) {
    state.summaryDataSales[0].value = payload.diff_sales_order ? currencyLocale(payload.diff_sales_order) : 'Rp. 0'
    state.summaryDataSales[1].value = payload.diff_redeem_alp ? currencyLocale(payload.diff_redeem_alp) : 'Rp. 0'
    state.summaryDataSales[2].value = payload.diff_promotion_ecommerce ? currencyLocale(payload.diff_promotion_ecommerce) : 'Rp. 0'
    state.summaryDataSales[3].value = payload.diff_sales_final ? currencyLocale(payload.diff_sales_final) : 'Rp. 0'
    state.summaryDataSales[4].value = payload.diff_delivery_fee ? currencyLocale(payload.diff_delivery_fee) : 'Rp. 0'
  },
  SET_TABLE_DATA_SALES(state, payload) {
    state.tableDataSales = payload
  },
  SET_SUMMARY_DATA_REFUND(state, payload) {
    state.summaryDataRefund[0].value = payload.diff_all_refund ? currencyLocale(payload.diff_all_refund) : 'Rp. 0'
    state.summaryDataRefund[1].value = payload.diff_refund_alp ? currencyLocale(payload.diff_refund_alp) : 'Rp. 0'
    state.summaryDataRefund[2].value = payload.diff_refund_xendit ? currencyLocale(payload.diff_refund_xendit) : 'Rp. 0'
    state.summaryDataRefund[3].value = payload.diff_refund_evoucher ? currencyLocale(payload.diff_refund_evoucher) : 'Rp. 0'
    state.summaryDataRefund[4].value = payload.diff_refund_limit ? currencyLocale(payload.diff_refund_limit) : 'Rp. 0'
  },
  SET_TABLE_DATA_REFUND(state, payload) {
    state.tableDataRefund = payload
  },
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_IS_LOADING_SUMMARY(state, payload) {
    state.isLoadingSummary = payload
  },
  RESET_SUMMARY_SALES(state) {
    const defaultState = getDefaultState()
    state.summaryDataSales = defaultState.summaryDataSales
  },
  RESET_SUMMARY_REFUND(state) {
    const defaultState = getDefaultState()
    state.summaryDataRefund = defaultState.summaryDataRefund
  }
}

const actions = {
  async fetchDifferenceReportSales(context, query) {
    try {
      context.commit('SET_IS_LOADING', true)
      const response = await apiGetAuth(API_PLANOGRAM_ANALYTICS.DIFFERENCE_REPORT_SALES, query)
      const responseData = response.data

      if (responseData && responseData.data.data === null) {
        responseData.data.data = []
      }

      context.commit('SET_TABLE_DATA_SALES', responseData.data.data)
      context.commit('SET_IS_LOADING', false)
    } catch (error) {
      notificationDanger(error)
      context.commit('SET_IS_LOADING', false)
    }
  },
  async fetchSummaryDataSales(context, query) {
    try {
      context.commit('SET_IS_LOADING_SUMMARY', true)
      const response = await apiGetAuth(API_PLANOGRAM_ANALYTICS.DIFFERENCE_REPORT_SALES_SUMMARY, query)
      const responseData = response.data

      context.commit('SET_SUMMARY_DATA_SALES', responseData.data)
    } catch (error) {
      notificationDanger(error)
    } finally {
      context.commit('SET_IS_LOADING_SUMMARY', false)
    }
  },
  async exportDifferenceReportSales (context, query) {
    try {
      const response = await apiGetAuthWithCustomHeadersResponseType(API_PLANOGRAM_ANALYTICS.DIFFERENCE_REPORT_SALES_EXPORT, query)
      exportCustomHeaderAndResponseType(response.data, 'export_difference_report_sales.csv')
    } catch (error) {
      notificationDanger(error)
    }
  },
  async fetchDifferenceReportRefund(context, query) {
    try {
      context.commit('SET_IS_LOADING', true)
      const response = await apiGetAuth(API_PLANOGRAM_ANALYTICS.DIFFERENCE_REPORT_REFUND, query)
      const responseData = response.data

      if (responseData && responseData.data.data === null) {
        responseData.data.data = []
      }

      context.commit('SET_TABLE_DATA_REFUND', responseData.data.data)
      context.commit('SET_IS_LOADING', false)
    } catch (error) {
      notificationDanger(error)
      context.commit('SET_IS_LOADING', false)
    }
  },
  async fetchSummaryDataRefund(context, query) {
    try {
      context.commit('SET_IS_LOADING_SUMMARY', true)
      const response = await apiGetAuth(API_PLANOGRAM_ANALYTICS.DIFFERENCE_REPORT_REFUND_SUMMARY, query)
      const responseData = response.data

      context.commit('SET_SUMMARY_DATA_REFUND', responseData.data)
    } catch (error) {
      notificationDanger(error)
    } finally {
      context.commit('SET_IS_LOADING_SUMMARY', false)
    }
  },
  async exportDifferenceReportRefund (context, query) {
    try {
      const response = await apiGetAuthWithCustomHeadersResponseType(API_PLANOGRAM_ANALYTICS.DIFFERENCE_REPORT_REFUND_EXPORT, query)
      exportCustomHeaderAndResponseType(response.data, 'export_difference_report_refund.csv')
    } catch (error) {
      notificationDanger(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
